<template>
  <v-dialog v-model="dialog" width="90%">

    <v-card elevation="3">

      <div class="pp-sidenav">
        <v-card-title class="white--text">
          Edit a Level
        </v-card-title>

        <v-card-subtitle class="white--text">
          Amend details below
        </v-card-subtitle>
      </div>

      <v-img
          src="/images/pp-logo.png"
          height="40"
          contain
          class="logo-course"
      >
      </v-img>
      <v-tabs
          dark
          width="250"
          color="primary"
          vertical
      >
        <v-tab class="pp-sidenav-2">
          <v-icon left>
            mdi-pencil
          </v-icon>
          Edit a Level
        </v-tab>

        <v-tab-item>
          <v-card flat v-if="currentLevelItem">
            <v-container>
              <template>
                <v-card
                    color="grey lighten-4"
                    width="100%" flat
                >
                  <v-card-title class="text-h6 grey lighten-3">
                    Edit <span class="primary--text ml-2"> {{ currentLevelItem.name }} </span>
                    <v-icon class="ml-1">mdi-chevron-right</v-icon>
                  </v-card-title>

                  <v-card-text>
                    <div class="py-10 px-2">
                      <v-row>
                        <v-text-field
                            v-model="editableLevelItem.name"
                            label="Level Title"
                            aria-required="true"
                            color="primary"
                            placeholder="Edit Level Title"
                            prepend-icon="mdi-file-edit-outline"
                            flat
                            solo
                            clearable
                        ></v-text-field>
                      </v-row>

                      <v-row v-if="levelApiError && levelApiError.fields && levelApiError.fields.name" class="err-text">
                        <p class="error--text">
                          Level name should not be empty and contain letters and/or numbers.
                        </p>
                      </v-row>

                      <v-row class="mb-5">
                        <v-textarea
                            v-model="editableLevelItem.description"
                            auto-grow
                            hint="The description of the Level will be publicly visible"
                            persistent-hint
                            label="Description"
                            aria-required="true"
                            color="primary"
                            placeholder="Edit Level Description"
                            prepend-icon="mdi-format-line-style"
                            flat
                            solo
                            clearable
                        ></v-textarea>
                      </v-row>

                      <v-row v-if="levelApiError && levelApiError.fields && levelApiError.fields.description" class="err-text">
                        <p class="error--text">
                          Level description should not be empty and contain letters and/or numbers.
                        </p>
                      </v-row>

                      <ImagePicker v-model="editableLevelItem.image"/>

                      <TagsInput
                          v-model="editableLevelItem.tags"
                          :validationError="levelApiError"
                      />

                      <v-row v-if="levelApiError">
                        <v-alert
                            text
                            color="red"
                            icon="mdi-alert-circle-outline"
                        >
                          There was an error in submission. Please check all fields and try again.
                        </v-alert>
                      </v-row>
                    </div>
                  </v-card-text>
                </v-card>
              </template>
            </v-container>
          </v-card>
          <div v-else>
            <UnavailableContent />
          </div>
        </v-tab-item>
      </v-tabs>

      <!-- ------------------------------------------ buttons ------------------------------------------ -->
      <div class="pp-sidenav">
        <div class="btm">
          <Loading v-if="levelItemLoading"/>
          <ConfirmCancelButtons
              :item="currentLevelItem"
              confirm-text="Save Changes"
              :confirm-disabled="levelItemLoading"
              :confirm-action="editItemConfirm"
              :cancel-action="closeDialog"/>
        </div>
      </div>
      <!-- ------------------------------------------end of buttons ------------------------------------------ -->
    </v-card>
  </v-dialog>
</template>

<script>
import Loading from "@/components/common/Loading";
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import { mapActions, mapGetters } from "vuex";
import UnavailableContent from "@/components/common/UnavailableContent";
import ImagePicker from "@/components/common/ImagePicker";
import TagsInput from "@/components/common/TagsInput";

export default {
  name: "LevelEdit",
  components: {ImagePicker, TagsInput, UnavailableContent, ConfirmCancelButtons, Loading},
  computed: {
    ...mapGetters([
      'levelApiError', 'openDialog', 'currentLevelItem', 'editableLevelItem', 'levelItemLoading',
    ]),
    dialog: {
      get () {
        return this.openDialog === 'levelEdit';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
  },
  methods: {
    ...mapActions(['editLevel', 'clearLevelItems', 'setOpenDialog', 'closeOpenDialog']),
    closeDialog() {
      this.closeOpenDialog();
      this.clearLevelItems();
    },
    async editItemConfirm() {
      const edited = await this.editLevel(this.editableLevelItem);

      if (edited) {
        this.closeOpenDialog();
      }
    },
  },
};
</script>
